import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

import React from 'react';
import { utils } from 'pro-gallery-lib';
import ImageItem from '../imageItem';
import PlayBackground from '../../svgs/components/play_background';
import PlayTriangle from '../../svgs/components/play_triangle';
import VideoItemPlaceholder from './videoItemPlaceholder';
var videoControls = [/*#__PURE__*/React.createElement("i", {
  key: "play-triangle",
  "data-hook": "play-triangle",
  className: 'gallery-item-video-play-triangle play-triangle '
}, /*#__PURE__*/React.createElement(PlayTriangle, null)), /*#__PURE__*/React.createElement("i", {
  key: "play-bg",
  "data-hook": "play-background",
  className: 'gallery-item-video-play-background play-background '
}, /*#__PURE__*/React.createElement(PlayBackground, null))];

var VideoItemWrapper = /*#__PURE__*/function (_ImageItem) {
  _inheritsLoose(VideoItemWrapper, _ImageItem);

  function VideoItemWrapper(props) {
    var _this;

    _this = _ImageItem.call(this, props) || this;
    _this.shouldPlayVideo = _this.shouldPlayVideo.bind(_assertThisInitialized(_this));
    _this.createVideoItemPlaceholder = _this.createVideoItemPlaceholder.bind(_assertThisInitialized(_this));
    _this.state = {
      VideoItemLoaded: false
    };
    return _this;
  }

  var _proto = VideoItemWrapper.prototype;

  _proto.shouldPlayVideo = function shouldPlayVideo() {
    var _this$props$stylePara = this.props.styleParams,
        videoPlay = _this$props$stylePara.videoPlay,
        itemClick = _this$props$stylePara.itemClick;
    var hasLink = this.props.hasLink;

    if (this.props.isVideoPlaceholder) {
      return false;
    }

    if (this.props.idx === this.props.playingVideoIdx || this.props.idx === this.props.nextVideoIdx) {
      if (videoPlay === 'hover' || videoPlay === 'auto') {
        return true;
      } else if (itemClick === 'nothing') {
        return true;
      } else if (itemClick === 'link' && !hasLink) {
        return true;
      }
    }

    return false;
  };

  _proto.createVideoItemPlaceholder = function createVideoItemPlaceholder(showVideoControls) {
    var props = utils.pick(this.props, ['alt', 'title', 'description', 'id', 'idx', 'styleParams', 'createUrl', 'settings', 'lazyLoad', 'actions']);
    return /*#__PURE__*/React.createElement(VideoItemPlaceholder, _extends({}, props, {
      key: "videoPlaceholder",
      imageDimensions: this.props.imageDimensions,
      isThumbnail: !!this.props.thumbnailHighlightId,
      id: this.props.idx,
      videoControls: showVideoControls && videoControls
    }));
  };

  _proto.componentDidMount = /*#__PURE__*/function () {
    var _componentDidMount = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var VideoItem;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return import(
              /* webpackChunkName: "videoItem" */
              './videoItem');

            case 3:
              VideoItem = _context.sent;
              this.VideoItem = VideoItem["default"];

              if (this.shouldPlayVideo()) {
                this.setState({
                  VideoItemLoaded: true
                });
              }

              _context.next = 11;
              break;

            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](0);
              console.error('Failed to fetch VideoItem');

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this, [[0, 8]]);
    }));

    function componentDidMount() {
      return _componentDidMount.apply(this, arguments);
    }

    return componentDidMount;
  }();

  _proto.render = function render() {
    var hover = this.props.hover;
    var showVideoControls = !this.props.hidePlay && this.props.styleParams.showVideoPlayButton;
    var videoPlaceholder = this.createVideoItemPlaceholder(showVideoControls);
    var VideoItem = this.VideoItem;

    if (!this.shouldPlayVideo() || !VideoItem) {
      return [videoPlaceholder, hover];
    }

    return /*#__PURE__*/React.createElement(VideoItem, _extends({}, this.props, {
      videoControls: showVideoControls && videoControls
    }));
  };

  return VideoItemWrapper;
}(ImageItem);

export default VideoItemWrapper;